import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { inject, ref, Ref } from 'vue';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { useInternationalOffersTracking } from '../tracking';
import { PopoverHelper } from '@/helpers/vfm/popover-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageDropDown',
  setup(__props) {

const dropDown = ref<{ $el: HTMLElement }>();
const offersLanguages = inject<Ref<string[]>>('offersLanguages', ref([]));
const searchLanguage = inject<Ref<string[]>>('searchLanguage', ref([]));
const setSearchLanguage = inject<(languages: string[]) => void>('setSearchLanguage', () => {});
const { trackInternationalOffers } = useInternationalOffersTracking({ title: null });

function openDropDown(event: Event) {
	trackInternationalOffers('languageDropdown');

	PopoverHelper.create({
		popoverProps: {
			cssClass: 'search-list__pop-over',
			boundingElement: event.currentTarget,
			anchor: 'left',
			position: 'left',
		},
		component: () => import('@/features/international-offers/components/LanguageList.vue'),
		componentProps: {
			offersLanguages: offersLanguages?.value,
			searchLanguage: searchLanguage?.value,
			setSearchLanguage: setSearchLanguage,
		},
		onOpened: () => {
			trackInternationalOffers('languageModalOpened');
		},
		onClosed: () => {
			trackInternationalOffers('languageModalClosed', {
				spec: { property: searchLanguage.value.sort().join(', ') },
			});
		},
	});
}

return { __sfc: true,dropDown, offersLanguages, searchLanguage, setSearchLanguage, trackInternationalOffers, openDropDown, BasicButton, faChevronDown }
}

})